import crypto from 'crypto'
import { getLiveConfigurationCache } from './configuration/configurationCache'

const selected = {
  // note: example structure
  // analyticsProvider: {
  //   bVariantProbability: null, // keep track of the last used probability to avoid recalculation
  //   cohort: null,
  // },
  mediaService: {
    bVariantProbability: null, // keep track of the last used probability to avoid recalculation
    cohort: null,
  },
}

export function chooseAOrBVariant(bVariantProbability, userId = null) {
  const bProbability = parseInt(bVariantProbability, 10)

  if (Number.isNaN(bProbability) || bProbability <= 0) {
    return 'A'
  }

  if (bProbability >= 100) {
    return 'B'
  }

  if (!userId) {
    return null
  }

  const hash = crypto
    .createHash('sha256')
    .update(userId)
    .digest('hex')

  // take first 8 hex chars -> 32-bit number
  const num = parseInt(hash.slice(0, 8), 16)
  const bucket = num % 100 // 0–99

  return bucket < bProbability ? 'B' : 'A'
}

function chooseAOrBVariantFromLocalStorage(bVariantProbability, experimentName) {
  const session = JSON.parse(localStorage.getItem('ls.session'))
  if (session?.user) {
    const cache = selected[experimentName] || {}
    if (cache.bVariantProbability !== bVariantProbability || !cache.cohort) {
      if (!selected[experimentName]) {
        selected[experimentName] = {}
      }
      selected[experimentName].bVariantProbability = bVariantProbability
      selected[experimentName].cohort = chooseAOrBVariant(bVariantProbability, session.user)
    }
    return selected[experimentName].cohort
  }
  return 'A'
}

export function shouldPresentBFeature(bVariantProbability, experimentName) {
  return chooseAOrBVariantFromLocalStorage(bVariantProbability, experimentName) === 'B'
}

export function shouldPresentMediaService() {
  const { mediaServiceUseProbability } = getLiveConfigurationCache() || {}
  // if default is 100, always use 100. otherwise use the configuration value if available
  const probability = process.env.REACT_APP_MEDIASERVICE_DEFAULT_USE_PROBABILITY === '100' ?
    '100' :
    mediaServiceUseProbability ?? process.env.REACT_APP_MEDIASERVICE_DEFAULT_USE_PROBABILITY
  return shouldPresentBFeature(probability, 'mediaService')
}
